export const dataHooks = {
  RadioOptionContainer: 'Radio-option-container',
  RadioContainer: 'Radio-container',
  RadioContent: 'Radio-content',
  RadioItem: 'Radio-item',
} as const;

export const dataAttr = {
  DISPLAY: 'data-display',
} as const;
